import React, {Component} from 'react';
import validate from './validation';
import {
    Chip,
    Grid,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Typography,
    TextField,
    Tab,
    Tabs,
} from 'material-ui';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import {Field, reduxForm} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {InputSelectField} from '../../../components/fields/field_input_select_blocks';
import {SimpleEditorField} from '../../../components/fields/field_simple_editor';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';
import {b64toBlob, toDataUrl} from '../../../components/helpers/helpers';
import {urlRegex} from '../../../components/helpers/constants';
import DropzoneImageField from '../../../components/fields/field_dropzone_image';
import ImageDetailsCropDialog from '../../../containers/builder/form/image_details_crop';
import ImageDetailsMetaDialog from '../../../containers/builder/form/image_details_meta';
import ImageSettings from '../../builder/form/image_settings';
import VideoSettings from '../../builder/form/video_settings';
import {TabContainer} from '../../../components/tab/tab_container';
import SortableImageList from '../../../containers/builder/form/sortable_image_list';
import PagePicker from '../../page-picker/page_picker';
import {BLOCK_TYPE_ACCREDITATION_ID} from '../types';

class BlockNewForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedImageSettings: false,
            expandedVideoSettings: false,
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageToView: null,
            src: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            valueTab: 0,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
            blockTypeId: null,
        };
    }

    onImageClick = (image, index) => {
        const {block} = this.props;

        if (image.new) {
            this.updateLocalStateWithBlockImages(image, index, block.images);
            let croppedImage = block.images[index].croppedImage;
            let croppedImageThumb = block.images[index].croppedImageThumb;
            if (croppedImage) {
                toDataUrl(croppedImage, (cropUrl) => {
                    this.setCroppedImageInState(cropUrl);
                });
            }
            if (croppedImageThumb) {
                toDataUrl(croppedImageThumb, (cropUrl) => {
                    this.setThumbCroppedImageInState(cropUrl);
                });
            }
        } else {
            const {title, alt, name, description, link} = block.images[index];
            this.setState({
                openCropPopup: true,
                openImageMetaPopup: true,
                imageToCrop: null,
                imageToView: image,
                imageIndex: index,
                imageMeta: {
                    title,
                    alt,
                    name,
                    description,
                    link,
                },
            });
        }
    };

    handleTabChange = (event, value) => {
        this.setState({
            valueTab: value,
        });
    };

    updateLocalStateWithBlockImages(image, index, images) {
        const {title, alt, name, description, link} = images[index];
        this.setState({
            openCropPopup: true,
            imageToCrop: image,
            imageIndex: index,
            imageMeta: {
                title,
                alt,
                name,
                description,
                link,
            },
        });
    }

    updateState() {
        this.setState({
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageIndex: null,
            src: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        });
    }

    setCroppedImageInState(croppedImage) {
        this.setState({
            cropResult: croppedImage,
        });
    }

    isAccomodationBlockSelected() {
        return this.state.blockTypeId === BLOCK_TYPE_ACCREDITATION_ID;
    }

    render() {
        const {
            block,
            destinations,
            blockTypes,
            tripFormats,
            typesOfWork,
            handleSubmit,
            pristine,
            touched,
            classes,
            loading,
            onUpdateImagesField,
            onDeleteImageField,
            onCropImage,
            onCropThumbImage,
            onImageMetaUpdate,
            imageSettings,
            expandedVideoSettings,
            selectedImageSettings,
            selectImageSetting,
            onUpdateImagesSortOrder,
            handleFormSubmit,
            imageRatios,
            onUpdateVideoUrlField,
            videoSettings,
            selectedVideoSettings,
            selectVideoSetting,
            pagePickerPopupOpen,
            togglePagePickerPopup,
            pageSearchCriteria,
            getAllReviewPages,
            pagePickerPage,
        } = this.props;

        const {
            valueTab,
            expandedImageSettings,
            openImageMetaPopup,
            imageMeta,
            imageToView,
            imageIndex,
            cropResult,
            thumbCropResult,
            imageToCrop,
            openCropPopup,
            errorUrl,
        } = this.state;

        let changeOrderTabProps = {
            disabled: false,
        };

        if (block.images.length < 2) {
            changeOrderTabProps.disabled = true;
        }

        let visibleImages = block.images.filter(
            (image) => image.deleted === false
        );

        let videosArray =
            block.videos === undefined || block.videos.length < 1
                ? [{id: 0, url: ''}]
                : block.videos;

        let pagePickerPageTitle = 'None Selected';
        if (pagePickerPage && typeof pagePickerPage.title !== 'undefined') {
            pagePickerPageTitle = pagePickerPage.title;
        }

        return (
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Heading title={'Add New Block'} />
                <Grid container id="select-fields">
                    <Grid item xs={12} md={6}>
                        <Field
                            className={classes.selectMenuItem}
                            id="select-block-type"
                            name="block_type_id"
                            component={InputSelectField}
                            label="Select Block Type"
                            options={blockTypes}
                            fullWidth={true}
                            InputLabelProps={{
                                required: true,
                            }}
                            onChange={(event) =>
                                this.setState({blockTypeId: event.target.value})
                            }
                        />
                    </Grid>
                    {!this.isAccomodationBlockSelected() && (
                        <React.Fragment>
                            <Grid item xs={12} md={6}>
                                <Field
                                    className={classes.selectMenuItem}
                                    id="select-destination"
                                    name="destination_id"
                                    component={InputSelectField}
                                    label="Select Destination"
                                    options={destinations}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    className={classes.selectMenuItem}
                                    id="select-trip-format"
                                    name="trip_format_id"
                                    component={InputSelectField}
                                    label="Select Trip Format"
                                    options={tripFormats}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Field
                                    className={classes.selectMenuItem}
                                    id="select-type-of-work"
                                    name="type_of_work_id"
                                    component={InputSelectField}
                                    label="Select Type of Work"
                                    options={typesOfWork}
                                    fullWidth={true}
                                />
                            </Grid>
                        </React.Fragment>
                    )}
                </Grid>
                <Grid container id="text-fields">
                    <Grid item xs={12}>
                        {!this.isAccomodationBlockSelected() && (
                            <Field
                                name="display_name"
                                component={InputTextField}
                                label="Name"
                                fullWidth={true}
                                InputLabelProps={{
                                    required: true,
                                }}
                            />
                        )}
                        <Field
                            name="title"
                            component={InputTextField}
                            label="Title"
                            fullWidth={true}
                        />
                        {!this.isAccomodationBlockSelected() && (
                            <Field
                                name="body"
                                component={SimpleEditorField}
                                label="Body *"
                            />
                        )}
                        {this.isAccomodationBlockSelected() && (
                            <React.Fragment>
                                <Chip
                                    className={classes.sectionLinkToPageChip}
                                    label={
                                        'Read more Page Link *: ' +
                                        pagePickerPageTitle
                                    }
                                    onClick={togglePagePickerPopup}
                                />
                                <Field
                                    name="button_text"
                                    component={InputTextField}
                                    label="Button Text *"
                                    fullWidth={true}
                                />
                            </React.Fragment>
                        )}
                    </Grid>
                </Grid>
                <Grid container id="image">
                    <Grid item xs={12}>
                        <Typography align="center" color="error">
                            Note: If the Video Url field is filled in, only the
                            video will be displayed on the page. No photos will
                            be displayed.
                        </Typography>

                        {block.images.length > 1 && (
                            <Typography
                                align="center"
                                className={classes.galleryError}
                            >
                                Note: In order to upload multiple images to
                                create a gallery all crop images must have the
                                same ratio of 9:5!
                            </Typography>
                        )}

                        <Tabs
                            value={valueTab}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleTabChange}
                        >
                            <Tab value={0} label="Upload Images" />
                            {visibleImages.length > 1 && (
                                <Tab
                                    value={1}
                                    label="Change Images Order"
                                    {...changeOrderTabProps}
                                />
                            )}
                        </Tabs>

                        {valueTab === 0 && (
                            <TabContainer>
                                <DropzoneImageField
                                    multiple={true}
                                    images={block.images}
                                    onImageDelete={(image, index) => {
                                        onDeleteImageField(image, index);
                                    }}
                                    onImageClick={this.onImageClick.bind(this)}
                                    onImagesDrop={(images) => {
                                        onUpdateImagesField(images);
                                    }}
                                />
                            </TabContainer>
                        )}
                        {valueTab === 1 && (
                            <TabContainer>
                                <SortableImageList
                                    items={visibleImages}
                                    onImagesSortOrder={(images) => {
                                        onUpdateImagesSortOrder(images);
                                    }}
                                />
                            </TabContainer>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        {block.images.length > 0 && (
                            <ExpansionPanel
                                style={{marginTop: '10px'}}
                                expanded={expandedImageSettings}
                                onChange={(event, expandedImageSettings) =>
                                    this.setState({
                                        expandedImageSettings,
                                    })
                                }
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Image Settings</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <ImageSettings
                                        imageSettings={imageSettings}
                                        selectedImageSettings={
                                            selectedImageSettings
                                        }
                                        selectImageSetting={selectImageSetting}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}
                    </Grid>
                    {!this.isAccomodationBlockSelected() && (
                        <Grid item xs={12}>
                            {videosArray.map((video, index) => (
                                <TextField
                                    key={index}
                                    margin="dense"
                                    id="video_url"
                                    label="Video Url"
                                    value={video.url || ''}
                                    onChange={(event) => {
                                        onUpdateVideoUrlField(
                                            video.id,
                                            event.target.value
                                        );

                                        if (
                                            event.target.value.match(urlRegex)
                                        ) {
                                            this.setState({
                                                errorUrl: false,
                                            });
                                        } else {
                                            this.setState({
                                                errorUrl: true,
                                            });
                                        }

                                        if (event.target.value === '') {
                                            this.setState({
                                                errorUrl: false,
                                            });
                                        }
                                    }}
                                    type="url"
                                    fullWidth
                                    error={errorUrl}
                                    helperText={
                                        errorUrl
                                            ? 'Please fill in a valid url like: www.google.com, https://google.com, http://google.com!'
                                            : 'Type the video URL here'
                                    }
                                />
                            ))}
                            {videosArray[0].url !== '' && (
                                <ExpansionPanel
                                    style={{marginTop: '10px'}}
                                    expanded={expandedVideoSettings}
                                    onChange={(event, expanded) =>
                                        this.setState({
                                            expandedVideoSettings: expanded,
                                        })
                                    }
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography>Video Settings</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <VideoSettings
                                            videoSettings={videoSettings}
                                            selectedVideoSettings={
                                                selectedVideoSettings
                                            }
                                            selectVideoSetting={
                                                selectVideoSetting
                                            }
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            )}
                        </Grid>
                    )}
                </Grid>
                <Grid container className={classes.blocksActionButtons}>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={(!touched && pristine) || loading}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                        />
                        <BackButton
                            link={'/blocks'}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>

                <PagePicker
                    open={pagePickerPopupOpen}
                    handleClose={togglePagePickerPopup}
                    allPagesBySearchCriteria={
                        this.props.allPagesBySearchCriteria
                    }
                    searchString={pageSearchCriteria}
                    onPick={(pageId, pageTitle) => {
                        this.props.onPickBlockPage(pageId, pageTitle);
                        togglePagePickerPopup();
                    }}
                    onSearchPages={(event) => {
                        this.props.onSearchPages(
                            event.target.value,
                            this.props.siteId,
                            getAllReviewPages
                        );
                    }}
                />

                <ImageDetailsMetaDialog
                    classes={classes}
                    open={openImageMetaPopup}
                    imageMeta={imageMeta}
                    image={imageToView}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                name,
                            },
                        });
                    }}
                    handleSubmit={() => {
                        onImageMetaUpdate(imageIndex, imageMeta);
                        this.updateState();
                    }}
                    handleCancel={() => {
                        this.updateState();
                    }}
                />

                <ImageDetailsCropDialog
                    cropResult={cropResult}
                    thumbCropResult={thumbCropResult}
                    imageToCrop={imageToCrop}
                    imageRatios={imageRatios}
                    open={openCropPopup}
                    imageMeta={imageMeta}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...imageMeta,
                                name,
                            },
                        });
                    }}
                    setCropResult={(cropResult) => {
                        this.setState({
                            cropResult,
                        });
                    }}
                    setThumbCropResult={(thumbCropResult) => {
                        this.setState({
                            thumbCropResult,
                        });
                    }}
                    setCropRatioId={(cropRatioId) => {
                        this.setState({
                            cropRatioId,
                        });
                    }}
                    handleSubmit={() => {
                        if (cropResult) {
                            let imageObject = b64toBlob(cropResult);
                            const imageUrlBlob = URL.createObjectURL(
                                imageObject
                            );
                            onCropImage(
                                imageIndex,
                                imageObject,
                                imageUrlBlob,
                                imageObject
                            );
                        }
                        if (thumbCropResult) {
                            let thumbImageObject = b64toBlob(thumbCropResult);
                            const imageThumbUrlBlob = URL.createObjectURL(
                                thumbImageObject
                            );
                            onCropThumbImage(
                                imageIndex,
                                thumbImageObject,
                                imageThumbUrlBlob,
                                thumbImageObject
                            );
                        }
                        onImageMetaUpdate(imageIndex, imageMeta);
                        this.updateState();
                    }}
                    handleClose={() => {
                        this.updateState();
                    }}
                />
            </form>
        );
    }
}

export default reduxForm({
    form: 'BlockNewForm',
    enableReinitialize: true,
    validate,
})(BlockNewForm);



// WEBPACK FOOTER //
// ./src/containers/blocks/forms/CreateBlockForm.jsx